import Features from './Features'

export enum FeatureFlag {
  AccountBalance = 'ACCOUNT_BALANCE',
  // AddItems = 'ADD_ITEMS',
  BuyPath = 'BUY_PATH',
  HomeTryOn = 'HTO',
  LookbuilderPdpEntrypoint = 'LOOKBUILDER_PDP_ENTRYPOINT',
  NewCheckout = 'NEW_CHECKOUT',
  NewWeddingsPage = 'NEW_WEDDINGS_PAGE',
  RemoveItems = 'REMOVE_ITEMS',
  StyledLooksOnboarding = 'STYLED_LOOKS_ONBOARDING',
}

/*
  Features and their default values go here.
  You almost certainly want your feature flag `false` by default.
  Try not to write tests that will pass or fail based on a feature
  flag. Instead, use them "higher up" in your code, like when you
  determine which module to use.

  isProduction is for legacy reasons. There are still UI tests that test for old features.
  This functionally enables them but disables them in non-Prod.
*/
// Uncomment as needed
const isProduction = window.TBT_ENV === 'prod'
// const isStaging = window.TBT_ENV === 'staging'
// const isDev = window.TBT_ENV === 'dev'
// const isLocal = window.TBT_ENV === 'development'

const featureFlags = new Features({
  [FeatureFlag.AccountBalance]: isProduction,
  // [FeatureFlag.AddItems]: true,
  [FeatureFlag.BuyPath]: true,
  [FeatureFlag.HomeTryOn]: true,
  [FeatureFlag.LookbuilderPdpEntrypoint]: false,
  [FeatureFlag.NewCheckout]: false,
  [FeatureFlag.NewWeddingsPage]: isProduction,
  [FeatureFlag.RemoveItems]: true,
  [FeatureFlag.StyledLooksOnboarding]: false,
})

export default featureFlags

export const isAddItemsActive = true // featureFlags.enabled(FeatureFlag.AddItems)
export const isBuyPathActive = featureFlags.enabled(FeatureFlag.BuyPath)
export const isHtoActive = featureFlags.enabled(FeatureFlag.HomeTryOn)
export const isNewCheckoutActive = featureFlags.enabled(FeatureFlag.NewCheckout)
export const isRemoveItemsActive = featureFlags.enabled(FeatureFlag.RemoveItems)
